import React from "react"

function IconMediaPause({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="media-pause"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-media-pause"
      {...props}
    >
      <path
        d="M9.102 5.015a1.67 1.67 0 0 1 1.664 1.518l.006.152v10.708a1.67 1.67 0 0 1-1.518 1.663l-.152.007H6.139a1.67 1.67 0 0 1-1.664-1.518l-.007-.152V6.685a1.67 1.67 0 0 1 1.519-1.663l.152-.007h2.963zm8.507 0a1.67 1.67 0 0 1 1.663 1.518l.007.152v10.708a1.67 1.67 0 0 1-1.518 1.663l-.152.007h-2.963a1.67 1.67 0 0 1-1.664-1.518l-.007-.152V6.685a1.67 1.67 0 0 1 1.518-1.663l.153-.007h2.963zM9.102 6.324H6.139a.36.36 0 0 0-.354.288l-.008.073v10.708c0 .174.124.32.289.354l.073.007h2.963c.175 0 .32-.124.354-.288l.007-.073V6.685a.36.36 0 0 0-.288-.354l-.073-.007zm8.507 0h-2.963a.36.36 0 0 0-.355.288l-.007.073v10.708c0 .174.124.32.289.354l.073.007h2.963c.174 0 .32-.124.354-.288l.007-.073V6.685a.36.36 0 0 0-.288-.354l-.073-.007z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMediaPause
